import styled from 'styled-components';
import { StyledText } from '@bigcommerce/big-design/dist/cjs/components/Typography/styled';

const CenteredText = styled(StyledText)`
	line-height: 38px;
`;

const getColor = (props) => {
	if (props.isDragAccept) return '#00e676';
	if (props.isDragReject) return '#ff1744';
	if (props.isFocused) return '#2196f3';
	return '#eeeeee';
};

const UploadContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	border-width: 2px;
	border-radius: 2px;
	border-color: ${(props) => getColor(props)};
	border-style: dashed;
	background-color: #fafafa;
	color: #bdbdbd;
	outline: none;
	transition: border 0.24s ease-in-out;
	cursor: pointer;
`;

export const RightAligned = styled(StyledText)`
	text-align: right;
	line-height: 38px;
`;

export const StyledComments = styled.p`
	color: red;
`;

export { CenteredText, UploadContainer };
